// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.directory {
    color: aliceblue;
    text-align: left;
    font-size: 13px;
    margin-bottom: 15px;

}

.started {
    color: #fff;
    text-align: left;
}

.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{
    color: #666666 !important;
    background: #919191 !important;
    border: 1px solid #999999 !important;
  
  }

.buildImage {
    background-color: #282B30;
    width: 200px;
    height: 200px;
    padding: 10px;
}

.buildImage image {
    width: 100% !important;
}

.deleteButton button{
    border-radius: 0 !important;
    width: fit-content;
    background-color: #777A84;
    color: #fff;
    box-shadow: none !important;
    padding: 6px 4px !important;
    font-size: 10px;
}
.deleteButton button:hover{
    background-color: #989ba3 !important;
}

.detailsItem{
margin-bottom: 10px;
padding: 5px;
}

.MuiTableRow-root{
    background-color: #282B30;

}
.MuiTableCell-root{
    border: none !important;

}
.MuiTableCell-body{
    color: #fff !important;
}
.MuiPaper-elevation1{
    box-shadow: none !important;
}
.MuiTableBody-root td:nth-child(4){
    width: 30px !important;
    text-align: right !important;
}
.MuiTableBody-root td:nth-child(3){
    width: auto !important;
    text-align: right !important;
}




.deleteButton button:hover {
    background-color: #777A84;
}

.circle {
    background-color: #E16162;
    border-radius: 50%;
    color: #fff;
    display: inline-flex;
    font-size: 20px;
    width: 30px;
    height: 30px;
    justify-content: center;
    margin-right: -40px !important;
    font-weight: bold;
}
.viewMore button{
    border-radius: 0 !important;
    font-size: 10px;
    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);
}

.viewMore button:hover{
    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);
}
.monitor {
    margin-top: 10px;
    text-align: left;
}

.monitor button {
    font-size: 12px;
    height: 30px;
    width: 130px;
    background-color: #E16162;
}

.monitor button:hover {
    background-color: #E16162;
}

.complexInfo {
    width: 80%;
    margin-left: 50px;
    height: fit-content;
    background-color: #282B30;
    padding: 20px;
  
}

.buildings {
    width: 80%;
    height: fit-content;
    background-color: #282B30;
    margin-top: 20px;
    padding: 20px;
    margin-left: 50px;
}



.infoTitle {
    margin: 0 !important;
    text-align: left !important;
    color: #fff;
    left: 0;
    /* <--------------------- required */
    top: 0;
    padding-left: 15px;
}

.infoTitle h2 {
    margin: 0 !important;
}

.infoButton {
    text-align: right;
    top: 0;
    /* <---------------------- required */
    right: 0;
    padding-right: 15px;
}
.tableContainer{
    margin: 10px;
}
.tableContainer table tbody tr{
    background-color: #1e2024;
    border-radius: 0 !important;
}

.tableContainer .MuiPaper-root{
    background-color: #1e2024;
    border-radius: 0 !important;
}

.infoButton button {
    border-radius: 0 !important;
    color: #fff;
    font-size: 10px;
    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);
}

.infoButton button:hover {
    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);
}

.description {
    margin-left: 10px;
    margin-top: 20px;
    width: 95%;
    height: fit-content;
    background-color: #1E2024;
    padding: 10px;
    text-align: left;
    color: #fff;
}

.titleItem{
    font-weight: bold;
    color: #d3d6e0;
}

.description-details{
    margin-top: 5px;
    background-color: #282B30;
    padding: 3px;
}

.desc{
    margin-top: 15px;
}

.css-177gid-MuiTableCell-root {
    text-align: left !important;
    color: #fff !important;
    border-bottom: none !important;
    border-left: 3px solid #4996EE;
    padding: 6px !important;
}

.css-1azl6jz-MuiTableCell-root {
    text-align: left !important;
    color: #fff !important;
    border-bottom: none !important;
}

.css-rqglhn-MuiTable-root {
   
    background-color: #282B30 !important;
    color: #fff !important;
}

.css-11xur9t-MuiPaper-root-MuiTableContainer-root {
    width: auto !important;
    background-color: #282B30 !important;
    color: #fff !important;
    box-shadow: none !important;
}

.mui-image-wrapper {
    width: auto !important;
}


@media only screen and (max-width: 1180px) and (min-width: 980px) {
    .complexInfo {
        width: 80%;
        margin-left: 80px;
       
    }

    .buildings {
        width: 80%;
   
        background-color: #282B30;
        margin-left: 80px;
    }
}



@media only screen and (max-width: 980px) and (min-width: 900px) {
    .complexInfo {
        width: 80%;
        margin-left: 120px;
 
    }

    .buildings {
        width: 80%;
       
        background-color: #282B30;
        margin-left: 120px;
    }
    
}

@media only screen and (max-width: 900px) {
    .complexInfo {
        width: 90%;
  
        margin-left: 0;

    }

    .buildings {
        width: 90%;

        background-color: #282B30;
        margin-top: 20px;
        margin-left: 0;
    }

    .buildImage {
        background-color: #282B30;
        width: auto;
        height: auto;
        padding: 10px;
    }

    .buildInfo {
        width: 95%;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/ComplexDetail/ComplexDetail.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;;AAEvB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,oCAAoC;;EAEtC;;AAEF;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,2BAA2B;IAC3B,2BAA2B;IAC3B,eAAe;AACnB;AACA;IACI,oCAAoC;AACxC;;AAEA;AACA,mBAAmB;AACnB,YAAY;AACZ;;AAEA;IACI,yBAAyB;;AAE7B;AACA;IACI,uBAAuB;;AAE3B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,sBAAsB;IACtB,4BAA4B;AAChC;AACA;IACI,sBAAsB;IACtB,4BAA4B;AAChC;;;;;AAKA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,8BAA8B;IAC9B,iBAAiB;AACrB;AACA;IACI,2BAA2B;IAC3B,eAAe;IACf,iFAAiF;AACrF;;AAEA;IACI,iFAAiF;AACrF;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;;AAEjB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,iBAAiB;AACrB;;;;AAIA;IACI,oBAAoB;IACpB,2BAA2B;IAC3B,WAAW;IACX,OAAO;IACP,oCAAoC;IACpC,MAAM;IACN,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,MAAM;IACN,qCAAqC;IACrC,QAAQ;IACR,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,WAAW;IACX,eAAe;IACf,iFAAiF;AACrF;;AAEA;IACI,iFAAiF;AACrF;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,8BAA8B;IAC9B,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;;IAEI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,oCAAoC;IACpC,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;;AAGA;IACI;QACI,UAAU;QACV,iBAAiB;;IAErB;;IAEA;QACI,UAAU;;QAEV,yBAAyB;QACzB,iBAAiB;IACrB;AACJ;;;;AAIA;IACI;QACI,UAAU;QACV,kBAAkB;;IAEtB;;IAEA;QACI,UAAU;;QAEV,yBAAyB;QACzB,kBAAkB;IACtB;;AAEJ;;AAEA;IACI;QACI,UAAU;;QAEV,cAAc;;IAElB;;IAEA;QACI,UAAU;;QAEV,yBAAyB;QACzB,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".directory {\n    color: aliceblue;\n    text-align: left;\n    font-size: 13px;\n    margin-bottom: 15px;\n\n}\n\n.started {\n    color: #fff;\n    text-align: left;\n}\n\n.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{\n    color: #666666 !important;\n    background: #919191 !important;\n    border: 1px solid #999999 !important;\n  \n  }\n\n.buildImage {\n    background-color: #282B30;\n    width: 200px;\n    height: 200px;\n    padding: 10px;\n}\n\n.buildImage image {\n    width: 100% !important;\n}\n\n.deleteButton button{\n    border-radius: 0 !important;\n    width: fit-content;\n    background-color: #777A84;\n    color: #fff;\n    box-shadow: none !important;\n    padding: 6px 4px !important;\n    font-size: 10px;\n}\n.deleteButton button:hover{\n    background-color: #989ba3 !important;\n}\n\n.detailsItem{\nmargin-bottom: 10px;\npadding: 5px;\n}\n\n.MuiTableRow-root{\n    background-color: #282B30;\n\n}\n.MuiTableCell-root{\n    border: none !important;\n\n}\n.MuiTableCell-body{\n    color: #fff !important;\n}\n.MuiPaper-elevation1{\n    box-shadow: none !important;\n}\n.MuiTableBody-root td:nth-child(4){\n    width: 30px !important;\n    text-align: right !important;\n}\n.MuiTableBody-root td:nth-child(3){\n    width: auto !important;\n    text-align: right !important;\n}\n\n\n\n\n.deleteButton button:hover {\n    background-color: #777A84;\n}\n\n.circle {\n    background-color: #E16162;\n    border-radius: 50%;\n    color: #fff;\n    display: inline-flex;\n    font-size: 20px;\n    width: 30px;\n    height: 30px;\n    justify-content: center;\n    margin-right: -40px !important;\n    font-weight: bold;\n}\n.viewMore button{\n    border-radius: 0 !important;\n    font-size: 10px;\n    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);\n}\n\n.viewMore button:hover{\n    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);\n}\n.monitor {\n    margin-top: 10px;\n    text-align: left;\n}\n\n.monitor button {\n    font-size: 12px;\n    height: 30px;\n    width: 130px;\n    background-color: #E16162;\n}\n\n.monitor button:hover {\n    background-color: #E16162;\n}\n\n.complexInfo {\n    width: 80%;\n    margin-left: 50px;\n    height: fit-content;\n    background-color: #282B30;\n    padding: 20px;\n  \n}\n\n.buildings {\n    width: 80%;\n    height: fit-content;\n    background-color: #282B30;\n    margin-top: 20px;\n    padding: 20px;\n    margin-left: 50px;\n}\n\n\n\n.infoTitle {\n    margin: 0 !important;\n    text-align: left !important;\n    color: #fff;\n    left: 0;\n    /* <--------------------- required */\n    top: 0;\n    padding-left: 15px;\n}\n\n.infoTitle h2 {\n    margin: 0 !important;\n}\n\n.infoButton {\n    text-align: right;\n    top: 0;\n    /* <---------------------- required */\n    right: 0;\n    padding-right: 15px;\n}\n.tableContainer{\n    margin: 10px;\n}\n.tableContainer table tbody tr{\n    background-color: #1e2024;\n    border-radius: 0 !important;\n}\n\n.tableContainer .MuiPaper-root{\n    background-color: #1e2024;\n    border-radius: 0 !important;\n}\n\n.infoButton button {\n    border-radius: 0 !important;\n    color: #fff;\n    font-size: 10px;\n    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);\n}\n\n.infoButton button:hover {\n    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);\n}\n\n.description {\n    margin-left: 10px;\n    margin-top: 20px;\n    width: 95%;\n    height: fit-content;\n    background-color: #1E2024;\n    padding: 10px;\n    text-align: left;\n    color: #fff;\n}\n\n.titleItem{\n    font-weight: bold;\n    color: #d3d6e0;\n}\n\n.description-details{\n    margin-top: 5px;\n    background-color: #282B30;\n    padding: 3px;\n}\n\n.desc{\n    margin-top: 15px;\n}\n\n.css-177gid-MuiTableCell-root {\n    text-align: left !important;\n    color: #fff !important;\n    border-bottom: none !important;\n    border-left: 3px solid #4996EE;\n    padding: 6px !important;\n}\n\n.css-1azl6jz-MuiTableCell-root {\n    text-align: left !important;\n    color: #fff !important;\n    border-bottom: none !important;\n}\n\n.css-rqglhn-MuiTable-root {\n   \n    background-color: #282B30 !important;\n    color: #fff !important;\n}\n\n.css-11xur9t-MuiPaper-root-MuiTableContainer-root {\n    width: auto !important;\n    background-color: #282B30 !important;\n    color: #fff !important;\n    box-shadow: none !important;\n}\n\n.mui-image-wrapper {\n    width: auto !important;\n}\n\n\n@media only screen and (max-width: 1180px) and (min-width: 980px) {\n    .complexInfo {\n        width: 80%;\n        margin-left: 80px;\n       \n    }\n\n    .buildings {\n        width: 80%;\n   \n        background-color: #282B30;\n        margin-left: 80px;\n    }\n}\n\n\n\n@media only screen and (max-width: 980px) and (min-width: 900px) {\n    .complexInfo {\n        width: 80%;\n        margin-left: 120px;\n \n    }\n\n    .buildings {\n        width: 80%;\n       \n        background-color: #282B30;\n        margin-left: 120px;\n    }\n    \n}\n\n@media only screen and (max-width: 900px) {\n    .complexInfo {\n        width: 90%;\n  \n        margin-left: 0;\n\n    }\n\n    .buildings {\n        width: 90%;\n\n        background-color: #282B30;\n        margin-top: 20px;\n        margin-left: 0;\n    }\n\n    .buildImage {\n        background-color: #282B30;\n        width: auto;\n        height: auto;\n        padding: 10px;\n    }\n\n    .buildInfo {\n        width: 95%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
